import React from "react";

const MediaIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg
    fill="none"
    {...props}
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
  >
     <path
      fill="#E7DEFF"
      d="M21.195 6.75a2.45 2.45 0 0 0-2.415-2.875H6.217A2.452 2.452 0 0 0 3.802 6.75m15.022-2.875c.032-.299.05-.447.05-.57a2.3 2.3 0 0 0-2.056-2.292C16.696 1 16.547 1 16.248 1H8.75c-.3 0-.45 0-.572.013a2.3 2.3 0 0 0-2.055 2.292c0 .123.016.272.05.57m9.294 10.483c.643.398.643 1.429 0 1.827l-3.877 2.403c-.624.388-1.391-.115-1.391-.913v-4.807c0-.797.767-1.3 1.391-.913l1.939 1.202 1.938 1.201Z"
    />
    <path
      stroke="#8065C9"
      strokeWidth={1.5}
      d="M21.195 6.75a2.45 2.45 0 0 0-2.415-2.875H6.217A2.452 2.452 0 0 0 3.802 6.75m15.022-2.875c.032-.299.05-.447.05-.57a2.3 2.3 0 0 0-2.056-2.292C16.696 1 16.547 1 16.248 1H8.75c-.3 0-.45 0-.572.013a2.3 2.3 0 0 0-2.055 2.292c0 .123.016.272.05.57m9.294 10.483c.643.398.643 1.429 0 1.827l-3.877 2.403c-.624.388-1.391-.115-1.391-.913v-4.807c0-.797.767-1.3 1.391-.913l1.939 1.202 1.938 1.201Z"
    />
    <path
      stroke="#8065C9"
      strokeWidth={1.5}
      d="M1.442 14.562c-.514-3.639-.77-5.457.32-6.636C2.852 6.75 4.793 6.75 8.673 6.75h7.655c3.88 0 5.82 0 6.911 1.178 1.09 1.177.833 2.995.32 6.634l-.486 3.45c-.402 2.852-.603 4.28-1.635 5.133-1.031.855-2.553.855-5.597.855H9.16c-3.043 0-4.566 0-5.597-.855-1.032-.854-1.233-2.28-1.636-5.133l-.485-3.45Z"
    />
    <path
      fill="#8065C9"
      d="m16.066 14.88-5.156-3.173-.793.397v6.344l.793.397 5.155-3.172v-.794Z"
    />
  </svg>
);

export default MediaIcon;
